import { LinkIcon } from "lucide-react";

import { prop, define } from "@/components/builder/utils";

import { DroppablePlaceholder } from "../utils/Placeholder";

import BasePreview from "./base";

function LinkPreview({ children, properties: { content, url: _, target: __, allowChildren, ...properties }, ...props }) {
  return <BasePreview properties={properties} {...props}>
    <a>
      {!allowChildren ? content : children || <DroppablePlaceholder>
        Drop here
      </DroppablePlaceholder>}
    </a>
  </BasePreview>
}

function LinkHTML({ content, url, target, attributes, allowChildren, children }) {
  return <a href={url} target={target || undefined} {...attributes}>
    {allowChildren ? children : content}
  </a>
}

export default define('link', LinkPreview, LinkHTML)
  .palete(<LinkIcon size={16} />, 'Link', 'Content')
  .canvas()
  .property(prop.predefined.customClass())
  .property(prop.predefined.children())
  .property(prop.predefined.content().ignoreDevice(true))
  .property(prop.predefined.url().ignoreDevice(true))
  .property(prop.predefined.target().ignoreDevice(true))
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .property(prop.predefined.attributes().props({ hiddenAttributes: ['target', 'href'] }))
  .defaultProps({
    content: "Link",
    textColor: 'blue-500',
    cursor: 'cursor-pointer',
  })
  .build()
